import { capitaliseFirstLetter, indefiniteArticle } from '../../utils'
import { CtaButton } from '../cta-button'

export interface SearchButtonProps {
  make: string
  model: string
  small?: boolean
  className?: string
  onClick?: () => void
}

export const SearchButton = ({
  make,
  model,
  small,
  className,
  onClick,
}: SearchButtonProps) => {
  const makeCapitalize = capitaliseFirstLetter(make)
  const modelCapitalize = capitaliseFirstLetter(model)
  const indefiniteArticleValue = indefiniteArticle(make)

  const formattedMake = make.toLowerCase().replace(/ /g, '-')
  const formattedModel = model.toLowerCase().replace(/ /g, '-')

  const searchButton = `Search for ${indefiniteArticleValue} ${makeCapitalize} ${modelCapitalize}`

  return (
    <CtaButton
      href={`/used-cars/${formattedMake}/${formattedModel}`}
      onClick={onClick}
      className={className}
      small={small}
    >
      {searchButton}
    </CtaButton>
  )
}
